import { memo } from 'react';

import glyphMap from './icon.json';

interface AntIconProps {
  name: string;
  size?: number;
  color?: string;
  className?: string;
}

function AntIcon({
  name,
  size = 16,
  color = '#373e41',
  className = '',
}: AntIconProps) {
  const glyph = (glyphMap as Record<string, number>)[name];

  return (
    <span
      className={className}
      style={{ fontSize: size, color, fontFamily: 'AntIcon' }}>
      {!!glyph ? String.fromCodePoint(glyph) : ''}
    </span>
  );
}

export default memo(AntIcon);
